import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditService } from '../base';
import {
  SalesDespatchItem,
  SalesDespatchItemAddRemove,
  SalesDespatchItemDespatchNote,
  SalesDespatchItemForOrder,
  SalesDespatchItemForStockReturn,
  SalesDespatchItemInvoice,
  SalesDespatchItemInvoiceAddRemove,
  SalesDespatchItemInvoiceDetail,
  SalesDespatchItemSalesPack,
  SalesInvoiceDespatchItemAddRemove,
  SalesPackDespatchItemAddRemove,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesDespatchItemService extends TmsWebBaseEditService<SalesDespatchItem, SalesDespatchItem> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesDespatchItem', $localize`Sales Despatch Items`);
  }

  getSalesPackDespatchItemForSalesPack(): Observable<SalesDespatchItem[]> {
    return this.httpService.get<SalesDespatchItem[]>(`${this.apiUrl}/SalesDespatchItemsForSalesPack`);
  }

  getSalesPackDespatchItemDetails(id: string): Observable<SalesDespatchItemSalesPack[]> {
    return this.httpService.get<SalesDespatchItemSalesPack[]>(
      `${this.apiUrl}/SalesDespatchItemsForSalesPackDetails/${id}`,
    );
  }

  getSalesDespatchItems(id: string): Observable<SalesDespatchItemDespatchNote[]> {
    return this.httpService.get<SalesDespatchItemDespatchNote[]>(`${this.apiUrl}/SalesDespatchItems/${id}`);
  }

  getSalesDespatchItemsForInvoice(id: string): Observable<SalesDespatchItemInvoice[]> {
    return this.httpService.get<SalesDespatchItemInvoice[]>(`${this.apiUrl}/SalesDespatchItemsForInvoice/${id}`);
  }

  getSalesDespatchNotesForInvoice(id: string): Observable<SalesDespatchItemInvoice[]> {
    return this.httpService.get<SalesDespatchItemInvoice[]>(`${this.apiUrl}/SalesDespatchNotesForInvoice/${id}`);
  }

  getSalesDespatchItemsForInvoiceDetail(id: string): Observable<SalesDespatchItemInvoiceDetail[]> {
    return this.httpService.get<SalesDespatchItemInvoiceDetail[]>(
      `${this.apiUrl}/SalesDespatchItemsForInvoiceDetail/${id}`,
    );
  }

  getSalesInvoiceDespatchItemsDetail(id: string): Observable<SalesDespatchItemInvoiceDetail[]> {
    return this.httpService.get<SalesDespatchItemInvoiceDetail[]>(
      `${this.apiUrl}/SalesInvoiceDespatchItemsDetail/${id}`,
    );
  }

  getSalesDespatchItemsForStockReturn(id: string): Observable<SalesDespatchItemForStockReturn[]> {
    return this.httpService.get<SalesDespatchItemForStockReturn[]>(
      `${this.apiUrl}/SalesDespatchItemsForStockReturn/${id}`,
    );
  }

  getSalesDespatchItemsForStockItem(id: string): Observable<SalesDespatchItemDespatchNote[]> {
    return this.httpService.get<SalesDespatchItemDespatchNote[]>(`${this.apiUrl}/SalesDespatchItemsForStockItem/${id}`);
  }

  getSalesDespatchItemsForOrder(id: string): Observable<SalesDespatchItemForOrder[]> {
    return this.httpService.get<SalesDespatchItemForOrder[]>(`${this.apiUrl}/SalesDespatchItemsForOrder/${id}`);
  }

  removeFromSalesPack(salesPackDespatchItemAddRemove: SalesPackDespatchItemAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/RemoveFromSalesPack`, salesPackDespatchItemAddRemove);
  }

  addToSalesPack(salesPackDespatchItemAddRemove: SalesPackDespatchItemAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/AddToSalesPack`, salesPackDespatchItemAddRemove);
  }

  removeFromSalesDespatchNote(salesDespatchItemAddRemove: SalesDespatchItemAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/RemoveFromSalesDespatchNote`, salesDespatchItemAddRemove);
  }

  addToSalesDespatchNote(salesDespatchItemAddRemove: SalesDespatchItemAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/AddToSalesDespatchNote`, salesDespatchItemAddRemove);
  }

  removeFromSalesInvoice(salesDespatchItemInvoiceAddRemove: SalesDespatchItemInvoiceAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/RemoveFromSalesInvoice`, salesDespatchItemInvoiceAddRemove);
  }

  addToSalesInvoice(salesDespatchItemInvoiceAddRemove: SalesDespatchItemInvoiceAddRemove): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/AddToSalesInvoice`, salesDespatchItemInvoiceAddRemove);
  }

  removeFromSalesInvoiceDespatchItem(
    salesInvoiceDespatchItemAddRemove: SalesInvoiceDespatchItemAddRemove,
  ): Observable<string> {
    return this.httpService.post<string>(
      `${this.apiUrl}/RemoveFromSalesInvoiceDespatchItem`,
      salesInvoiceDespatchItemAddRemove,
    );
  }

  addToSalesInvoiceDespatchItem(
    salesInvoiceDespatchItemAddRemove: SalesInvoiceDespatchItemAddRemove,
  ): Observable<string> {
    return this.httpService.post<string>(
      `${this.apiUrl}/AddToSalesInvoiceDespatchItem`,
      salesInvoiceDespatchItemAddRemove,
    );
  }

  updateSalesInvoicePrice(salesDespatchItemId: string, invoicePrice: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateSalesInvoicePrice`, {
      salesDespatchItemId,
      invoicePrice,
    });
  }

  refreshSalesInvoicePrice(salesInvoiceHeaderId: string) {
    return this.httpService.post<any>(`${this.apiUrl}/RefreshSalesInvoicePrice`, {
      salesInvoiceHeaderId,
    });
  }

  amendDespatchItem(model: SalesDespatchItemDespatchNote): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/AmendDespatchItem`, model);
  }
}
